import React from 'react'
import { Argument as ClassName } from 'classnames'
import { useMediaPredicate } from 'react-media-hook'

import { WidgetDropdownFilterModal } from '../widget-dropdown-filter-modal'
import { WidgetDropdownFilterPopup } from '../widget-dropdown-filter-popup'
import { LogTypes } from '../../common/constants/LogTypes'

export type WidgetDropdownFilterProps = {
    options: Array<LogTypes>
    defaultOptions: Array<LogTypes>
    filterButtonRef: React.MutableRefObject<HTMLButtonElement | null>
    onClose: () => void
    onChange: (options: Array<LogTypes>) => void
    className?: ClassName
    style?: React.CSSProperties
}

export function WidgetDropdownFilter({
    onClose,
    defaultOptions,
    onChange,
    options,
    filterButtonRef,
}: WidgetDropdownFilterProps): React.ReactElement {
    const isMobileScreen = useMediaPredicate('(max-width: 900px)')

    return isMobileScreen ? (
        <WidgetDropdownFilterModal
            onChange={onChange}
            onClose={onClose}
            options={options}
            defaultOptions={defaultOptions}
        />
    ) : (
        <WidgetDropdownFilterPopup
            onChange={onChange}
            onClose={onClose}
            options={options}
            defaultOptions={defaultOptions}
            filterButtonRef={filterButtonRef}
        />
    )
}
